
import { Component, Vue } from "vue-property-decorator";
import QuestionCard from "@/components/question/QuestionCard.vue";
@Component({
  components: {
    QuestionCard
  }
})
export default class CssText extends Vue {
  radio = 6;
  radio2 = "1";
  text = "nihao1";
  input3 = "你好啊";
  checkList = ["选中且禁用", "复选框 A"];
  tableData = [
    {
      name: "小名",
      time: "2020.1.1至2021.1.1",
      status: 1,
      question: 3,
      people: 10
    },
    {
      name: "小名",
      time: "2020.1.1至2021.1.1",
      status: 1,
      question: 3,
      people: 10
    },
    {
      name: "小名",
      time: "2020.1.1至2021.1.1",
      status: 1,
      question: 3,
      people: 10
    },
    {
      name: "小名",
      time: "2020.1.1至2021.1.1",
      status: 1,
      question: 3,
      people: 10
    },
    {
      name: "小名",
      time: "2020.1.1至2021.1.1",
      status: 1,
      question: 3,
      people: 10
    },
    {
      name: "小名",
      time: "2020.1.1至2021.1.1",
      status: 1,
      question: 3,
      people: 10
    },
    {
      name: "小名",
      time: "2020.1.1至2021.1.1",
      status: 1,
      question: 3,
      people: 10
    }
  ];
  questions = [
    {
      type: 5, //填空
      blankQuestionConfig: {
        answerList: [
          { score: 0, words: "小名" },
          { score: 0, words: "没错" }
        ],
        desc: "我的名字（），这个智能啊（）<p></p>",
        ignoreBlank: 1,
        scoreAll: 10,
        scoreType: 1,
        strictOrder: 1
      },
      questionId: 3365
    },
    {
      aiDimensionList: [],
      answers: [
        {
          content: "<p>这是参考答案</p>",
          isRight: 0,
          key: "A",
          keyScore: 0,
          questionAnswerId: 18405,
          sort: 1
        }
      ],
      audioUrl: "",
      companyIndex: 32,
      desc: "<p>这是一道有参考答案的视频题</p>",
      descTextOnly: "这是一道有参考答案的视频题",
      descVideo1: "",
      descVideo2: "",
      descVideoCover1: "",
      descVideoCover2: "",
      difficultLevel: 3,
      isCandidateUsed: 0,
      questionConfig: "",
      questionId: 3367,
      remark: "我是视频题的备注",
      score: 10,
      type: 6,
      videoQuestionConfig: null
    },
    {
      type: 5, //填空
      blankQuestionConfig: {
        answerList: [
          { score: 0, words: "小名" },
          { score: 0, words: "没错" }
        ],
        desc: "我的名字（），这个智能啊（）<p></p>",
        ignoreBlank: 1,
        scoreAll: 10,
        scoreType: 1,
        strictOrder: 1
      },
      questionId: 3365
    },
    {
      type: 1, //单选
      answers: [
        {
          content: "<p>赵云</p>",
          isRight: 0,
          key: "A",
          keyScore: 0,
          questionAnswerId: 18397,
          sort: 1
        },
        {
          content: "<p>秦始皇</p>",
          isRight: 0,
          key: "B",
          keyScore: 0,
          questionAnswerId: 18398,
          sort: 2
        },
        {
          content: "<p>康熙</p>",
          isRight: 1,
          key: "C",
          keyScore: 0,
          questionAnswerId: 18399,
          sort: 3
        },
        {
          content: "<p>商鞅</p>",
          isRight: 0,
          key: "D",
          keyScore: 0,
          questionAnswerId: 18400,
          sort: 4
        }
      ],
      descTextOnly: "这是普通单选题 增确答案是C",
      remark: "这是备注内容",
      score: 5,
      audioUrl: "",
      companyIndex: 30,
      desc: "<p>这是普通单选题 增确答案是C</p>",
      descVideo1: "",
      descVideo2: "",
      descVideoCover1: "",
      descVideoCover2: "",
      difficultLevel: 3,
      isCandidateUsed: 0,
      questionConfig: "",
      questionId: 3365
    },
    {
      type: 1, //单选
      answers: [
        {
          content: "<p>赵云</p>",
          isRight: 0,
          key: "A",
          keyScore: 0,
          questionAnswerId: 18397,
          sort: 1
        },
        {
          content: "<p>秦始皇</p>",
          isRight: 0,
          key: "B",
          keyScore: 0,
          questionAnswerId: 18398,
          sort: 2
        },
        {
          content: "<p>康熙</p>",
          isRight: 1,
          key: "C",
          keyScore: 0,
          questionAnswerId: 18399,
          sort: 3
        },
        {
          content: "<p>商鞅</p>",
          isRight: 0,
          key: "D",
          keyScore: 0,
          questionAnswerId: 18400,
          sort: 4
        }
      ],
      descTextOnly: "这是普通单选题 增确答案是C",
      remark: "这是备注内容",
      score: 5,
      audioUrl: "",
      companyIndex: 30,
      desc: "<p>这是普通单选题 增确答案是C</p>",
      descVideo1: "",
      descVideo2: "",
      descVideoCover1: "",
      descVideoCover2: "",
      difficultLevel: 3,
      isCandidateUsed: 0,
      questionConfig: "",
      questionId: 3365
    }
  ];

  changeRadio(e: string) {
    // this.radio = e;
  }
}
